export const addNew = {
    "title": {
        "NGO": "Add your Environmental Non-Governmental Organizations",
        "business": "Add your Eco-Friendly Business",
        "government": "Add an Environmental Government Agency",
        "media": "Add your Media Company",
        "hotSpot": "Add your Hot Spot",
        "greenSpot": "Add your Green Spot"
    },
    "titleText": "The short name of the problem that will be described in the hotspot. For example, air pollution in Raipur, India.",
    "back": "To contact",
    "business": "Eco business",
    "ngo": "NGO",
    "type": "Choose type*",
    "name": "Name*",
    "category": "Category*",
    "fieldTitleText": "The category that most closely matches the name of the hotspot.",
    "fieldBusiness": "Field business*",
    "fieldNgo": "Field NGO*",
    "general": "General",
    "country": "Country*",
    "address": "Address*",
    "addressTitleText": "The exact location of the hotspot.",
    "website": "Website URL*",
    "description": "Description (optional)",
    "email": "Email*",
    "nameDefault": "What is the name?",
    "categoryDefault": "What is the business category?",
    "fieldBusinessDefault": "What are the fields of activity?",
    "fieldNgoDefault": "What are the fields of activity?",
    "addressDefault": "Where are they located?",
    "countryDefault": "Where do they operate?",
    "websiteDefault": "Official website URL",
    "descriptionDefault": "Add description (main activities, goals ect)",
    "emailDefault": "Add your email",
    "clearAll": "Clear All",
    "logo": "Logo (optional)",
    "locationTitleText": "The countries where the hot spot is located.",
    "send": "Send",
    "error": "Please, write {{name}}",
    "logoShould": "Logo should be up to 100kb, png/jpg/svg.",
    "fields": "Fields*",
    "photoTitle": "Photos",
    "photoTitleUrl": "URL",
    "photoTitleUrlText": "A link to an image that displays the state of the hotspot at any given moment.",
    "photoTitleUrlAlt": "ALT",
    "photoTitleUrlAltText": "A brief description of the image that is located at the specified URL.",
    "photoUrl": "Photo URL",
    "photoAlt": "Photo Alt",
    "linkTitle": "Links",
    "linkTitleUrl": "URL",
    "linkTitleUrlText": "A link to a reputable website that describes the problem.",
    "linkTitleUrlAlt": "NAMES",
    "linkTitleUrlAltText": "A short name of a reputable website.",
    "linkAlt": "Photo Alt",
    "linkUrl": "Link URL",
    "linkName": "Link Name",
    "videoTitle": "Videos",
    "videoTitleUrl": "URL",
    "videoTitleUrlText": "A link to a video (preferably Youtube) showing the hotspot at any given time",
    "videoTitleUrlAlt": "TITLE",
    "videoTitleUrlAltText": "The short title of the video above",
    "videoUrl": "Video URL",
    "orgTitle": "Related Organizations",
    "orgTitleUrl": "URL",
    "orgTitleUrlText": "A link to the company that deals with the control and solution of the hotspot problem",
    "orgTitleUrlAlt": "NAME",
    "orgTitleUrlAltText": "The name of the organization to which the link points",
    "orgUrl": "Organisation URL",
    "orgName": "Name",
    "emailHotSpotTitle": "EMAIL",
    "emailHotSpotTitleText": "Your Email",
    "timelines": "Timelines",
    "timelinesTitleText": "A detailed chronology of events that took place in this hotspot.",
    "timelineDate": "Year-Month-Day",
    "timelineFullDate": "Timeline Date",
    "timelineText": "Description for this date",
    "timelineDescriptionTitleText": "A brief description of the events that took place during the specified period of time.",
    "problemTitle": "Problem Title",
    "problemTitleText": "A subheading to the main heading.",
    "problemDescription": "Description Problem",
    "problemDescriptionText": "A detailed description of the hotspot (when and how the hotspot appeared, what is the reason for its formation, what is the threat to humans and the environment).",
    "solutionName": "Solution name",
    "solutionTitleText": "A short title to the text about solving the problem",
    "solutionDescriptionText": "A detailed description of the practical solution to the problem (what resources and funds are needed to solve this issue)",
    "solutionAuthor": "Solution author",
    "solutionLink": "Solution link",
    "solutionText": "Solution text",
    "titleSeo": "Title SEO",
    "descSeo": "Description SEO"
}
export const filterType = {
    "countries": "Countries",
    "organizationFields": "NGO fields",
    "category": "Business category",
    "businessFields": "Business fields",
    "searchType": "Search type ",
    "searchHere": "Search here",
    "btnEnterNext": "Next",
    "newsFields": "Fields",
    "hotSpotFields": "Hot spot fields"
}